import * as React from 'react';
import { Tooltip } from '@mui/material';

interface CardTitleProps {
  title: string;
  tooltipText?: string | null;
}

const CardTitle = ({ title, tooltipText }: CardTitleProps) => (
  <Tooltip title={tooltipText} enterDelay={1000}>
    <div>{title}</div>
  </Tooltip>
);

export default CardTitle;
